export enum FilterDateRangeTypeEnum { // update PRESET_DATE_TYPES if adding one more not range value to work
  RANGE = 'range',
  LAST_12_MONTHS = 'last_12_months',
  LAST_7_DAYS = 'last_7_days',
  THIS_CALENDAR_YEAR = 'this_calendar_year',
}

export const filterDateRangeDateTypeOptions = [
  { text: 'Static Range', value: FilterDateRangeTypeEnum.RANGE },
  { text: 'Last 7 days', value: FilterDateRangeTypeEnum.LAST_7_DAYS },
  { text: 'Last 12 months', value: FilterDateRangeTypeEnum.LAST_12_MONTHS },
  { text: 'This calendar year', value: FilterDateRangeTypeEnum.THIS_CALENDAR_YEAR },
];

export const filterDateRangeLabels: Partial<Record<FilterDateRangeTypeEnum, string>> = {
  [FilterDateRangeTypeEnum.LAST_7_DAYS]: 'Last 7 days',
  [FilterDateRangeTypeEnum.LAST_12_MONTHS]: 'Last 12 months',
  [FilterDateRangeTypeEnum.THIS_CALENDAR_YEAR]: 'This calendar year',
}
